var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.45 5.4a.75.75 0 01.15 1.05l-5.613 7.484a1.25 1.25 0 01-1.976.03L7 10.202 3.586 14.47a.75.75 0 11-1.172-.937l3.61-4.512a1.25 1.25 0 011.952 0l3.005 3.756L16.4 5.55a.75.75 0 011.05-.15z",
    clipRule: "evenodd"
  })));
}

export default SvgAnalytics;